import { SessionToken } from '@/models/session-token'

export class AdminSession {
  userId?: string;
  companyId?: string;
  role?: string;
  mail?: string;
  token?: SessionToken

  constructor(params?: Partial<AdminSession>) {
    Object.assign(this, params)
  }
}